import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Modal, Table
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import $ from 'jquery';
import readXlsxFile from 'read-excel-file';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';
import axios from "axios";
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import _ from 'lodash';
import * as FileSaver from "file-saver";
import LoadingOverlay from 'react-loading-overlay';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSVNew from '../../../Common/exportcsvnew';

var url = window.location.hostname;
var port = window.location.port;



class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleFailed = this.toggleFailed.bind(this);
    this.processData = this.processData.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.SuccessConfirmoktoggle = this.SuccessConfirmoktoggle.bind(this);
    
    this.accessCookie = this.accessCookie.bind(this);
    this.toggleInvalidModal = this.toggleInvalidModal.bind(this);
    this.toggleInvalidModalCancel = this.toggleInvalidModalCancel.bind(this);
    /*this.ExcelDateToJSDate = this.ExcelDateToJSDate.bind(this);*/
    /*this.toShortFormat = this.toShortFormat.bind(this);*/
    this.state = {
	  loading_overlay: false,
      icld_header: [
        { "SR.No":"","PTL ID": "", "Zone": "", "Basepack Code": "", "CBU Code": "","Batch": "","LB SKU ID": "","LB SKU Product Name": "","MRP": "","UPC": "", "PKD": "", "Total Quantity": "", "ICLD Quantity": "", "Tester": "" },
      ],
	  loose_header: [
        { "SR.No":"","PTL ID": "", "Zone": "", "Basepack Code": "", "CBU Code": "","Batch": "","LB SKU ID": "","LB SKU Product Name": "","MRP": "","UPC": "", "PKD": "", "Total Quantity": "", "ICLD Quantity": "","Loose Quantity" : "", "Tester": "" },
      ],
	  tester_header: [
        { "PTL ID":"","Zone":"","Order Date":"","Tester Order Number":"","Party Code":"","Party Name":"","Sales Beat":"","Basepack Code":"","Shade Code":"","Shade Name":"","Product Description":"","Order Quantity":"" },
      ],
	  breakpack_header: [
        { "Sl.No":"","Order ID":"","PTL ID":"","Zone":"","Basepack Code":"","CBU Code":"","Batch":"","LB SKU ID":"","LB SKU Product Name":"","MRP":"","UPC":"","PKD":"","Total Quantity":"","ICLD Quantity":"","Loose Quantity":"","Tester":"","RETAILER Code":""},
      ],
	  ordertester_header: [
        { "Tester Order Number":"","Order Date":"","Hul code":"","Party code":"","Basepack Code":"","Order Quantity":"","Cross Dock distributor id":"","Distributor Name":"","Cross Dock Facility Code":"","Created Datetime":"" },
      ],
	  outer_header: [
        { "SR.No":"","Order Number":"","Parent Party Code":"","CPS ID":"","Zone":"","Basepack Code":"","CBU Code":"","Batch":"","LB SKU ID":"","LB SKU Product Name":"","MRP":"","CPO":"","UPC":"","PKM":"","Total Quantity":"","OCLD Quantity":"","OCLD Flag":"","Retailer Type":"","Priority":"" },
      ],
      showPassword: false,
	  responseModal: false,
	  responseModalMsg: null,
      file: {},
      data: [],
      cols: [],
      modal: false,
      modalFailed: false,
      showAllItem: false,
      showInvalidItem: false,
      showProceedbtn: false,
      SuccessConfirmmodal: false,
      loadingconfirmbtn: false,
      failed_message: '',
      fileName: '',
      loading: false,
	  pickType_optionval : "",
      disabledBtn: false,
      dateNewVal: '',
      stn_date_formate: '',
	  showICLDData : false,
	  showLooseData : false,
	  showTesterData : false,
	  showBreakpackData : false,
	  showBatchTesterData : false,
	  showCartonData : false,
      table_header: ['GRN Number' , 'GRN Line Number' , 'Basepack Code', 'Basepack Description' , 'CBU Code', 'SKU7 Code' , 'LB SKU ID' , 'LB SKU Product Name' , 'PKD' , 'Batch' , 'MRP', 'UPC' , 'Received ICLD Quantity' , 'Tester Quantity' , 'Tester Flag' , 'STN Date' , 'STN Number' , 'Storage Type' , 'Fast Moving', 'Crate ID' ,'GRN Date Time', 'Remarks' ],
      validation: {
        "Bin Master": {
          "GRN Number": "string",
          "GRN Line Number": "number",
          "Basepack Code": "string",
          "Level": "number",
          "Rack": "number",
          "Rack type": "string",
          "Storage type": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },
      },
    };
  }


  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  responseModalToggle = () => {
	this.setState({
		responseModal: !this.state.responseModal
	});
  }
  componentWillMount(){
      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41" + ":8090";

      }else{
        url= window.location.hostname + port;
      }

       

      var cookieUsername = this.getCookie('token');
      var Location = this.getCookie('selectedLocation');
      var username = this.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: Location
      })

      console.log("token" + this.state.userName)

      localStorage.setItem('userName' , username);
    }



   

  accessCookie(cookieName)
        {
          var name = cookieName + "=";
          var allCookieArray = document.cookie.split(';');
          for(var i=0; i<allCookieArray.length; i++)
          {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
         }
        return "";
        } 


        getCookie(cname) {
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }


  toggleFailed() {
    this.setState(prevState => ({ modalFailed: !prevState.modalFailed }));

    
  }

  SuccessConfirmtoggle() {
    this.setState(prevState => ({ SuccessConfirmmodal: !prevState.SuccessConfirmmodal }));

    
  }

  toggleInvalidModal() {
    this.setState(prevState => ({ showInvalidModal: !prevState.showInvalidModal }));
    
  }

  toggleInvalidModalCancel(){
    this.fileInput.value = "";
    $(".upload_error").css('display', 'none');
    $(".upload_success").css('display', 'none');
    this.setState({
      showInvalidModal: false
    })
  }

  SuccessConfirmoktoggle(){
    this.setState({
      SuccessConfirmmodal: false
    })

    window.location.href= "/picking/printPickingSheet";
    
  }

  processData(){
    this.setState({
      loadingconfirmbtn: true,
      disabledBtn: true
    })

    console.log(this.state.selectedOptionVal.value);

      var arr = []
     console.log(JSON.stringify(this.state.data.length));
      addAnalytics('Upload Picksheet', 'Confirm Picksheet Upload', this.state.data);
    

     for(var i = 0; i < this.state.data.length; i++) {
          
          console.log(this.state.data[i]['GRN Number']);
        var orderData  = {};
	 if(this.state.data[i]['TP ID'] != undefined && this.state.data[i]['TP ID'] != ""){
          orderData['tpid'] = this.state.data[i]['TP ID'];
	 }else{
		 orderData['ptlId'] = this.state.data[i]['PTL ID'];
	 }
		  
          orderData['zone'] = this.state.data[i]['Zone'];
          orderData['basePackCode'] = this.state.data[i]['Basepack Code'];
          orderData['cbuCode'] = this.state.data[i]['CBU Code'];
          orderData['batch'] = this.state.data[i]['Batch'];
          orderData['lbSKUid'] = this.state.data[i]['LB SKU ID'];
          orderData['lbSKUProductName'] = this.state.data[i]['LB SKU Product Name'];
          orderData['mrp'] = this.state.data[i]['MRP'];
          orderData['upc'] = this.state.data[i]['UPC'];
          orderData['pkd'] = this.state.data[i]['PKD'];
          orderData['totalQuantity'] = this.state.data[i]['Total Quantity'];
          orderData['testerQuantity'] = 0;
		  
      if (this.state.selectedOptionVal.value.toLowerCase() == "carton" || this.state.selectedOptionVal.value.toLowerCase() == "outer"){
			  orderData['CPO'] = this.state.data[i]['CPO'];
			  orderData['orderType'] = this.state.data[i]['Outer Quantity'];
			  orderData['OrderId'] = this.state.data[i]['ORDER No'];
			  //orderData['pkm'] = this.state.data[i]['PKM'];
			  orderData['ocldflag'] = this.state.data[i]['OCLD Flag'];
			  orderData['retailerType'] = this.state.data[i]['Retailer Type'];
			  orderData[ "Tester"]= "no";
		  }else{
			 orderData['icldQuantity'] = this.state.data[i]['ICLD Quantity'];
			 orderData['looseQantity'] = this.state.data[i]['Loose Quantity'];  
		  }
		  
          /*orderData['remarks'] = 'dfghjk';*/

          
          arr.push(orderData);
      }

    
      
      
      console.log(arr);
      console.log(this.state.table_header.length);

      /*this.state.data.forEach(function(jsonobj){
            this.state.table_header.forEach(function(header_text){
              if (jsonobj[header_text] == undefined){
                jsonobj[header_text] = "";
            }
          });
      });*/


      /*if (this.state.responseFailLBSKUData.failure_response.length>0) {
          $(".error_file_uploaded").css('display', 'block');
        }else{
          
       $(".error_file_uploaded").css('display', 'none');*/
       const payload = {
        arr_data: this.state.data,
        location: this.state.selectedLocation,
        fileName: this.state.fileName,
        pickType: this.state.selectedOptionVal.value,
        create: true,
      };
    
    API.post('/picking/pick_sheet_upload/v1/', { param: payload })
      
      .then((response) =>  {

        this.setState({
          responseFailLBSKUData: response.data,
          responseSuccessLBSKUData: response.data,
          /*data: data,*/
         /* showInvalidItem: true,*/
          modalFailed: false,
          loadingconfirmbtn: false
        })


        
        this.setState({
          responseFailLBSKUData: response.data,
          responseSuccessLBSKUData: response.data,
         
          modalFailed: false
        })

        this.SuccessConfirmtoggle();

       

        console.log(this.state.data);
      })
      .catch(function (error) {
        
        
    });
   


  }

  togglePressCancel(){
      this.setState({
        /*showInvalidItem: false,*/
        modalFailed: false,
        loading: false,
      },() => {if (document.getElementById("my_file_input") !== null) {
		  document.getElementById("my_file_input").value = "";
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
		}
		document.getElementById("my_file_input").style.width = "35%";
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');})

  }

  change = (selectedOption) => {
    this.setState({ selectedOption,
                  selectedFileType:selectedOption.label,
                  selectedOptionVal:selectedOption
                  /*showInvalidProductItem: false,
                  showRowDataErrorProduct: false,
                  showInvalidBaseItem: false,
                  showRowDataErrorBase: false,
                  showRowDataError: false,
                  showInvalidItem: false*/


     });
	 if (selectedOption.value === "ICLD") {
      //this.fetchBinData();
      this.setState({
        showICLDData: true,
		showLooseData: false,
		showOrderTesterData: false,
		showBatchTesterData:false,
		showCartonData: false,
      });
    } else if (selectedOption.value === "LOOSE") {
      //this.fetchBaseData();
      this.setState({
        showICLDData: false,
		showLooseData: true,
		showOrderTesterData: false,
		showBatchTesterData:false,
		showCartonData: false,
      });
    }else if (selectedOption.value === "TESTER") {
      //this.fetchBaseData();
      this.setState({
        showICLDData: false,
		showLooseData: false,
		showOrderTesterData: true,
		showBatchTesterData:false,
		showCartonData: false,
      });
	  }else if (selectedOption.value === "BREAKPACK") {
      //this.fetchBaseData();
      this.setState({
        showICLDData: false,
		showLooseData: false,
		showBreakpackData: true,
		showOrderTesterData: false,
		showBatchTesterData:false,
		showCartonData: false,
      });
    }else if (selectedOption.value === "BATCH_TESTER") {
      //this.fetchBaseData();
      this.setState({
        showICLDData: false,
		showLooseData: false,
		showOrderTesterData: false,
		showBatchTesterData:true,
		showCartonData: false,
      });
    }else if (selectedOption.value === "carton") {
      //this.fetchBaseData();
      this.setState({
        showICLDData: false,
		showLooseData: false,
		showOrderTesterData: false,
		showBatchTesterData:false,
		showCartonData: true,
      });
    }else if (selectedOption.value === "ALL") {
      //this.fetchBaseData();
      this.setState({
        showICLDData: false,
		showLooseData: false,
		showOrderTesterData: false,
		showBatchTesterData:false,
		showCartonData: false,
      });
    }
      

    console.log(`Option selected:`, selectedOption.value);
  }


  


 /*handleFile() {
    console.log('dfghjmk');
    
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
 
    reader.onload = (e) => {
      
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true });
      
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      
      const data = XLSX.utils.sheet_to_json(ws);
     
      this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
        console.log(JSON.stringify(this.state.data, null, 2));
      });
 
    };*/
 
    /* var arr = []
     console.log(JSON.stringify(this.state.data.length));
    
      
      for(var i = 0; i < this.state.data.length; i++) {
          
          console.log(this.state.data[i]['GRN Number']);
        var orderData  = {};
          orderData['GRNNumber'] = this.state.data[i]['GRN Number'];
          orderData['GNRLineNumber'] = this.state.data[i]['GRN Line Number'];
          orderData['basePackCode'] = this.state.data[i]['Basepack Code'];
          orderData['basePackDescription'] = this.state.data[i]['Basepack Description'];
          orderData['cbuCode'] = this.state.data[i]['CBU Code'];
          orderData['sku7Code'] = this.state.data[i]['SKU7 Code'];
          orderData['lbSKUid'] = this.state.data[i]['LB SKU ID'];
          orderData['lbSKUProductName'] = this.state.data[i]['LB SKU Product Name'];
          orderData['pkd'] = this.state.data[i]['PKD'];
          orderData['batch'] = this.state.data[i]['Batch'];
          orderData['mrp'] = this.state.data[i]['MRP'];
          orderData['upc'] = this.state.data[i]['UPC'];
          orderData['receivedICLDQuantity'] = this.state.data[i]['Received ICLD Quantity'];
          orderData['testerQuantity'] = this.state.data[i]['Tester Quantity'];
          orderData['testerFlag'] = this.state.data[i]['Tester Flag'];
          orderData['stnDate'] = this.state.data[i]['STN Date'];
          orderData['stnNumber'] = this.state.data[i]['STN Number'];
          orderData['storageType'] = this.state.data[i]['Storage Type'];
          orderData['fastMoving'] = this.state.data[i]['Fast Moving'];
          orderData['crateId'] = this.state.data[i]['Crate ID'];
          orderData['grnDateTime'] = this.state.data[i]['GRN Date Time'];
          orderData['remarks'] = 'dfghjk';

          
          arr.push(orderData);
      }

      console.log(arr);


      axios
    .post(('http://3.215.84.36:8088/picking/inv_upload/v1/' , 

      {

        arr_data: arr,
        location: 'bhi',
        create: false,
      },

     {
       headers: {
            'Content-Type': 'application/json'
            
          } 

     }
     

     )
      .then((response) =>  {

        console.log(response);
       

      })
      .catch(function (error) {
        
        
    });*/
  /*}*/


  
  

/*toShortFormat(){
  var month_names =["Jan","Feb","Mar",
                      "Apr","May","Jun",
                      "Jul","Aug","Sep",
                      "Oct","Nov","Dec"];
    
    var day = this.getDate();
    var month_index = this.getMonth();
    var year = this.getFullYear();
    
    var stn_date=  "" + day + "-" + month_names[month_index] + "-" + year;
    this.setState({
      stn_date_formate : stn_date,
    })
}*/

  handleFile() {
    /* Boilerplate to set up FileReader */
	if(this.state.selectedOptionVal === null || this.state.selectedOptionVal === undefined){
		this.setState({
			responseModal: true,
			responseModalMsg: "Select at least one PickType"
		});
		return false;
    }
    
	if(this.state.file.name === undefined || this.state.file.name === null){
		this.setState({
			responseModal: true,
			responseModalMsg: "Select at least one File"
		});
		return false;
    }
     var ref = this;
     if (this.state.restrictProcess == true) {
      this.setState({
        showInvalidModal: true
      })

    }else{

    this.setState({
      loading: true,
      showInvalidItem: false,
      showTesterItem: false,
      showAllItem: false,
	  loading_overlay: true
    })
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
 
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true, cellDates: true });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws,{raw:false,dateNf: 'YYYY-MM-DD'})

      var XL_row_object = XLSX.utils.sheet_to_row_object_array(
          wb.Sheets[wsname],
          { header: 1, blankRows: false }
        );
      var json_object = XL_row_object;
      
      // const formattedData = data.map(item => {
      //   if(item['stnDate'])
      // })
      /* Update state */
      console.log(json_object);
	  var mandatory_field = false;
      var uploaded_file_header = json_object[0];

      if (this.state.selectedOption.value === "ICLD") {
		var sample_file_header = Object.keys(this.state.icld_header[0]);
	  }else if (this.state.selectedOption.value === "LOOSE") {
		var sample_file_header = Object.keys(this.state.loose_header[0]);
	  }else if (this.state.selectedOption.value === "TESTER") {
		var sample_file_header = Object.keys(this.state.ordertester_header[0]);
	  }else if (this.state.selectedOption.value === "BREAKPACK") {
		var sample_file_header = Object.keys(this.state.breakpack_header[0]);
	  }else if (this.state.selectedOption.value === "BATCH_TESTER") {
		var sample_file_header = Object.keys(this.state.tester_header[0]);
	  }else if (this.state.selectedOption.value === "carton") {
		var sample_file_header = Object.keys(this.state.outer_header[0]);
	  }
      
	  if(parseInt(uploaded_file_header.length) !== parseInt(sample_file_header.length) ){
		  ref.setState({
					loading: false,
					responseModal: true,
					responseModalMsg: "Invalid Format",
                    loading_overlay: false,
				});
			return false;
      }

      for (let i = 0; i < uploaded_file_header.length; i++){
		  if (uploaded_file_header[i] !== sample_file_header[i]){
			 ref.setState({
					loading: false,
					responseModal: true,
					responseModalMsg: "Invalid Format",
                    loading_overlay: false,
				});
			return false;
		  }
	  }
      
      for (let i = 1; i < json_object.length; i++) { 
        for(let j = 0; j < Object.keys(json_object[0]).length; j++){
           if (this.state.selectedOption.value === "BATCH_TESTER" || this.state.selectedOption.value === "TESTER") {
                if([6,8,9].indexOf(parseInt(j)) <= -1){
					if (json_object[i][j] === "" || json_object[i][j] === undefined) {
						mandatory_field = true;
					}
                }
		   }else{
		       if (json_object[i][j] === "" || json_object[i][j] === undefined) {
			      mandatory_field = true;
			   }
		   }
		}
      }
	  
      if (mandatory_field === true) {
          //alert("Data is inconsistent! Modify and upload again");
          ref.setState({
			modalFailed: true,
			//validationModal: true,
			//validationMessage: "Data is inconsistent! Modify and upload again",
            loading: false,
			loading_overlay: false
		  });
          return false;
      }

	  if(this.state.selectedOptionVal.value.toLowerCase() == "carton" || this.state.selectedOptionVal.value.toLowerCase() == "outer"){
		data.map((data_row) =>  data_row["Tester"] = "no");
	  }
	  
	  if(this.state.selectedOptionVal.value.toLowerCase() == "batch_tester" || this.state.selectedOptionVal.value.toLowerCase() == "tester"){
		  data.map((data_row,i) =>  data_row["SR.No"] = (i+1).toString());
	  }
	  
	  this.setState({
		  pickType_optionval : this.state.selectedOptionVal.value
	  });
      this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
        /*console.log(JSON.stringify(this.state.data, null, 2));*/
        /*let invalidItems = this.state.data.filter(item => !this.validateItem(item))*/



        var arr = []
     /*console.log(JSON.stringify(this.state.data.length));*/
        addAnalytics('Upload Picksheet', 'Picksheet Upload', this.state.data);
    
      
      for(var i = 0; i < this.state.data.length; i++) {
          
          /*console.log(this.state.data[i]['GRN Number']);*/
          var orderData  = {};
          orderData['ptlId'] = this.state.data[i]['PTL ID'];
          orderData['zone'] = this.state.data[i]['Zone'];
          orderData['basePackCode'] = this.state.data[i]['Basepack Code'];
          orderData['cbuCode'] = this.state.data[i]['CBU Code'];
          orderData['batch'] = this.state.data[i]['Batch'];
          orderData['lbSKUid'] = this.state.data[i]['LB SKU ID'];
          orderData['lbSKUProductName'] = this.state.data[i]['LB SKU Product Name'];
          orderData['mrp'] = this.state.data[i]['MRP'];
          orderData['upc'] = this.state.data[i]['UPC'];
          orderData['pkd'] = this.state.data[i]['PKD'];
          orderData['totalQuantity'] = this.state.data[i]['Total Quantity'];
          orderData['icldQuantity'] = this.state.data[i]['ICLD Quantity'];
          orderData['looseQantity'] = this.state.data[i]['Loose Quantity'];
		  //orderData['version'] = this.state.data[i]['Version'];
          orderData['testerQuantity'] = 0;
		  
		  
		  /* Handle Outer Carton FILE */

          
          /*orderData['remarks'] = 'dfghjk';*/

          
          arr.push(orderData);
      }

      /*console.log(arr);
      console.log(this.state.table_header.length);*/

      /*this.setState({
          
          loading: false,
          data: data,
          showAllItem: true,
          showProceedbtn: true,

        })*/

       /* localStorage.setItem('table_data' , JSON.stringify(arr));
        var tableData = localStorage.getItem('table_data');
        var parseTableData = JSON.parse(tableData);
        console.log(parseTableData);*/

      /*this.state.data.forEach(function(jsonobj){
            this.state.table_header.forEach(function(header_text){
              if (jsonobj[header_text] == undefined){
                jsonobj[header_text] = "";
            }
          });
      });*/
      const payload = {
        arr_data: this.state.data,
        location: this.state.selectedLocation,
        fileName: this.state.fileName,
        pickType: this.state.selectedOptionVal.value,
        create: false,
      };
    
    API.post('/picking/pick_sheet_upload/v1/', { param: payload })
      
      .then((response) =>  {

        /*console.log("length"+response.data.failure_response.length);*/

        /*if (response.data.success=== false) {
          this.setState({
            failed_message: response.data.message
          })
          this.toggleFailed();

        } else {
          this.toggle();
        }*/

       /* let data = this.state.data
        response.data.failure_response.map(item => {
          if(!item.status){
            const index = _.findIndex(data, dataItem => item.lb_sku_id == dataItem['LB SKU ID'])
            data[index].error = item.message
          }
        })*/

       /* if (response.data.failure_response.length>0) {
          this.toggleFailed();
          
          this.setState({
            showError: true,
          })
        }else{
          this.toggle();
          
        }

        if (response.data.failure_response.length>0) {
          console.log(response.data.failure_response.length);
          this.setState({
            showProceedbtn: true
          })

          console.log(this.state.showProceedbtn);
        }else if (response.data.failure_response.length===0){
          console.log(response.data.failure_response.length);
          console.log("sdfghjsdfghjdfg");
          this.setState({
            showProceedbtn: true
          })
        }
        

        this.setState({
          responseFailLBSKUData: response.data,
          loading: false,
          responseSuccessLBSKUData: response.data,
          data: data,
         

        })*/

        if (this.state.selectedOptionVal.value === "TESTER") {
          
          let data = this.state.data
        response.data.failure_response.map(item => {
          if(!item.status){
            const index = _.findIndex(data, dataItem => item.sr_no+item.base_pack_code == dataItem["SR.No"]+dataItem['Basepack Code'])
            data[index].error = item.message
          }
        })



        if (response.data.failure_response.length>0) {
          this.toggleFailed();
          
          this.setState({
            showError: true,
          })
        }else{
          this.toggle();
          
        }

        if (response.data.failure_response.length>0) {
          this.setState({
            showProceedbtn: true
          })
        }else if (response.data.failure_response.length===0){
          this.setState({
            showProceedbtn: true
          })
        }
        

        this.setState({
          responseFailLBSKUData: response.data,
          loading: false,
          responseSuccessLBSKUData: response.data,
          data: data,
		  
         /* showAllItem: true,*/

        })


          this.setState({
            showAllItem: false,
            showTesterItem: true

          })
          
        }else{


          let data = this.state.data
        response.data.failure_response.map((item) => {
          if(!item.status){
			if (this.state.selectedOptionVal.value === "BATCH_TESTER") {
				let base_pack_lbsku = item.sr_no+item.base_pack_code;
			    
				const index = _.findIndex(data, dataItem => base_pack_lbsku == dataItem["SR.No"]+dataItem["Basepack Code"])
				data[index].error = item.message
			}else{
				if (this.state.selectedOptionVal.value === "BREAKPACK") {
					let base_pack_lbsku = item.sr_no+item.base_pack_code+item.lb_sku_id;
					console.log("CONSOLE - ",base_pack_lbsku);
					const index = _.findIndex(data, dataItem => base_pack_lbsku == dataItem["Sl.No"]+dataItem["Basepack Code"]+dataItem['LB SKU ID'])
					data[index].error = item.message
				}else{
					let base_pack_lbsku = item.sr_no+item.base_pack_code+item.lb_sku_id;
					const index = _.findIndex(data, dataItem => base_pack_lbsku == dataItem["SR.No"]+dataItem["Basepack Code"]+dataItem['LB SKU ID'])
					data[index].error = item.message
				}
				
			}
			
          }
        })
        




        if (response.data.failure_response.length>0) {
          this.toggleFailed();
          
          this.setState({
            showError: true,
          })
        }else{
          this.toggle();
          
        }

        if (response.data.failure_response.length>0) {
          this.setState({
            showProceedbtn: true
          })
        }else if (response.data.failure_response.length===0){
          this.setState({
            showProceedbtn: true
          })
        }
        

        this.setState({
          responseFailLBSKUData: response.data,
          loading: false,
          responseSuccessLBSKUData: response.data,
          data: data,
         /* showAllItem: true,*/

        })







          this.setState({
            showAllItem: true,
            showTesterItem: false
          })



        }
		this.setState({
            loading_overlay:false
          })
		if (document.getElementById("my_file_input") !== null) {
	    document.getElementById("my_file_input").value = "";
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
		}
		document.getElementById("my_file_input").style.width = "35%";
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');
      })
      .catch(function (error) {
        console.log("ERRR -",error.response.status);
                if(parseInt(error.response.status) === 500){
					var msg = "Data is missing";
				}else{
					var msg = "Something went wrong in API";
				}
				ref.setState({
					loading: false,
					responseModal: true,
					responseModalMsg: msg,
                     loading_overlay: false,
				});
		if (document.getElementById("my_file_input") !== null) {
			document.getElementById("my_file_input").value = "";
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
		}
		document.getElementById("my_file_input").style.width = "35%";
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');  
    });



      });
 
    };
 
    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    };
    }
	
  }

  handleChange(evt) {
    const files = evt.target.files;
    const file_name = evt.target.value;
    console.log(file_name);
    var getFile = file_name.replace(/C:\\fakepath\\/i, '');
    var getFilereplace = getFile.replace('.xlsx', '');
    console.log(getFilereplace);

    this.setState({
      fileName: getFilereplace,
	  loading_overlay: true,
    })
	
    if (files && files[0]) {
		this.setState({ 
		file: files[0] 
		})
	}else{
		this.setState({ 
		loading_overlay: false,
        file: {},
		})
        $(".upload_success").css('display', 'none');
      $(".upload_error").css('display', 'none');
      $('.button_enable').removeAttr('disabled','disabled');
        return false;
	};

    var file1 = evt.target.value
    var fileArray1 = evt.target.value.split('.')
    var extension1 = fileArray1[fileArray1.length - 1];
    if (document.getElementById("my_file_input") !== null) {
      document.getElementById("my_file_input").style.color = "";
	  document.getElementById("my_file_input").style.width = "85%";
      document.getElementById("picking_label").style.display = "none";
    }else{
		document.getElementById("my_file_input").style.width = "35%";
	}
    if(extension1 != 'xlsx' && extension1 != 'csv' && extension1 != 'xls'){
    
      $(".upload_error").css('display', 'block');
      $(".upload_success").css('display', 'none');
       this.setState({
        restrictProcess: true
      })
    }else {
      $(".upload_success").css('display', 'block');
      $(".upload_error").css('display', 'none');
      $('.button_enable').removeAttr('disabled','disabled');
       this.setState({
        restrictProcess: false,
		loading_overlay: false
      })
    }
  };

  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { SuccessConfirmmodal, showInvalidModal } = this.state;
	const groupStyles = {
	  display: "flex",
	  alignItems: "center",
	  justifyContent: "space-between",
	  fontSize: 15,
	  fontWeight: "bold"
	};
	const groupBadgeStyles = {
	  backgroundColor: "#EBECF0",
	  borderRadius: "2em",
	  color: "#172B4D",
	  display: "inline-block",
	  fontSize: 12,
	  fontWeight: "normal",
	  lineHeight: "1",
	  minWidth: 1,
	  padding: "0.16666666666667em 0.5em",
	  textAlign: "center"
	};
	const formatGroupLabel = (data) => (
		<div style={groupStyles}>
			<span>{data.label}</span>
			<span style={groupBadgeStyles}>{data.options.length}</span>
		</div>
	);

    return (
	
      <Col xl={12}>
	  {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' /> }
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text"></h5>
              
            </div>

             <form className="form form--inline" onSubmit={e => e.preventDefault()}>
              
              <div className="form__form-group col-xl-3" style={{display: 'contents'}}>
                
                <span className="form__form-group-label col-xl-4" style={{display: 'none', paddingTop: 6, paddingBottom: 6}} >Select Type</span>
                

                
                <div className="form__form-group-field col-xl-4" style={{margin:"initial",display:"block"}}>
                  <Select
                    name="select"
                    label="Select"
                    component={renderSelectField}
                    value={selectedOption} 
                    onChange={this.change} 
					placeholder={"Select Pick Type"}
                    options={[
						{"label" :"Batch Pick","options":[{ value: 'ICLD', label: 'ICLD' },{ value: 'LOOSE', label: 'Loose' },{ value: 'BATCH_TESTER', label: 'Tester' }]},
						{"label" :"Order Pick","options":[{ value: 'TESTER', label: 'Tester' },{ value: 'BREAKPACK', label: 'Breakpack' },{ value: 'carton', label: 'Outer Carton'}]},
						{ value: 'ALL', label: 'All' }
                    ]}
					formatGroupLabel={formatGroupLabel}
                  />
                </div>
                
                
              </div>
            
            

              <div className="form__form-group col-xl-4">
               
                <div className="col-xl-12"  style={{border: "1px solid #ced4da"}}>
                  <input style={{paddingTop: 8,  height: 38,color: "transparent",width:"35%",border:"0px"}}
                    name="defaultInput"
                    component="input"
                    type="file"
                    placeholder="Default Input"
                    onChange={this.handleChange}
					id="my_file_input"
                    ref={ref=> this.fileInput = ref}
                  />
				  
				  <label for="files" id="picking_label">
                    Select and Upload Picksheet
                  </label>
                </div>
                <div className="col-xl-12">
                  <span style={{display: 'none' , color:'red'}} className="upload_error"> Invalid file format. Please select .xls, .xlsx, .csv file format </span>
                  <span style={{display: 'none' , color:'green', marginTop: 8}} className="upload_success"> Valid file format </span>
                </div>
                
              </div>

              <div className="form__form-group col-xl-2">
               <ButtonToolbar className="form__button-toolbar">
                    <Button className="btn-sm button_enable " style={{borderRadius: 5, backgroundColor:'#70bbfd', color:'#fff',textTransform:"capitalize",marginLeft:'auto'}} id="button_enable" onClick={this.handleFile} >
                    {this.state.loading && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }

                    Proceed
                    </Button>
                </ButtonToolbar>
              </div>
			  
			 {this.state.showICLDData && (
              <div className="form__form-group col-xl-2" style={{display:'inline'}}>
                <button
                  color="primary"
                  className="btn-sm button_enable "
                  style={{
                    backgroundColor: "#fff",
                    color: "rgb(112, 187, 253)",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
				  onClick={(e) =>
                    exportToCSVNew(
                      this.state.icld_header,
                      "ICLD_Template"
                    )
                  }
                  
                >
                  Sample Template
                </button>
                
              </div>
				)}
				
				{this.state.showLooseData && (
              <div className="form__form-group col-xl-2" style={{display:'inline'}}>
                <button
                  color="primary"
                  className="btn-sm button_enable "
                  style={{
                    backgroundColor: "#fff",
                    color: "rgb(112, 187, 253)",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
				  onClick={(e) =>
                    exportToCSVNew(
                      this.state.loose_header,
                      "Loose_Template"
                    )
                  }
                  
                >
                  Sample Template
                </button>
                
              </div>
				)}
				
				{this.state.showOrderTesterData && (
              <div className="form__form-group col-xl-2" style={{display:'inline'}}>
                <button
                  color="primary"
                  className="btn-sm button_enable "
                  style={{
                    backgroundColor: "#fff",
                    color: "rgb(112, 187, 253)",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
				  onClick={(e) =>
                    exportToCSVNew(
                      this.state.ordertester_header,
                      "Order_Pick_Tester_Template"
                    )
                  }
                  
                >
                  Sample Template
                </button>
                
              </div>
				)}
				
				{this.state.showBatchTesterData && (
              <div className="form__form-group col-xl-2" style={{display:'inline'}}>
                <button
                  color="primary"
                  className="btn-sm button_enable "
                  style={{
                    backgroundColor: "#fff",
                    color: "rgb(112, 187, 253)",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
				  onClick={(e) =>
                    exportToCSVNew(
                      this.state.tester_header,
                      "Batch_Pick_Tester_Template"
                    )
                  }
                  
                >
                  Sample Template
                </button>
                
              </div>
				)}
				
				{this.state.showCartonData && (
              <div className="form__form-group col-xl-2" style={{display:'inline'}}>
                <button
                  color="primary"
                  className="btn-sm button_enable "
                  style={{
                    backgroundColor: "#fff",
                    color: "rgb(112, 187, 253)",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
				  onClick={(e) =>
                    exportToCSVNew(
                      this.state.outer_header,
                      "Outer_Template"
                    )
                  }
                  
                >
                  Sample Template
                </button>
                
              </div>
				)}
            
            </form>
			<div className="notes" style={{paddingTop:'0px',paddingLeft:"15px"}}>		
              <p style={{marginBottom: '13px',fontSize: '15px'}}><b>Note</b> : 1. Choose ICLD from Batch Pick option in "Select Pick Type" dropdown to process ICLD batch picksheet.</p>
			  <p style={{marginBottom: '13px',fontSize: '15px',paddingLeft:'47px'}}>2. Choose Loose / Tester from Batch Pick option in "Select Pick Type" dropdown to process the Loose batch picksheet.</p>
              <p style={{marginBottom: '13px',fontSize: '15px',paddingLeft:'47px'}}>3. Choose Loose / Tester from Batch Pick option in "Select Pick Type" dropdown to process the Tester batch picksheet.</p>
			  <p style={{marginBottom: '13px',fontSize: '15px',paddingLeft:'47px'}}>4. Choose Tester from Order Pick option in "Select Pick Type" dropdown to process the Tester order picksheet.</p>
			  <p style={{marginBottom: '13px',fontSize: '15px',paddingLeft:'47px'}}>5. Choose Outer Carton from the Order Pick option in "Select Pick Type" dropdown to process the Outer Carton order picksheet.</p>
			 </div> 


          </CardBody>


          {
            this.state.showInvalidItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text"> </h4>
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>LB SKU ID</th>
                        <th>Response</th>
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.responseFailLBSKUData.failure_response.length>0 && (
                      this.state.responseFailLBSKUData.failure_response.map((item, index) => (
                        <tr>
                          <td>{item.lb_sku_id}</td>
                          <td style={{color: 'red'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }

                    {
                      this.state.responseSuccessLBSKUData.success_response.length>0 && (
                      this.state.responseSuccessLBSKUData.success_response.map((item, index) => (
                        <tr>
                          <td>{item.lb_sku_id}</td>
                          <td style={{color: 'green'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }



          {
            this.state.showAllItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div className="table_header">
                  <ButtonToolbar className="form__button-toolbar">
                      {this.state.showProceedbtn && (
                      <Button color="primary" className="btn-sm show_confirm_button" disabled={this.state.disabledBtn} onClick={this.processData} type="submit">
                      {this.state.loadingconfirmbtn && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    } 
                      Confirm</Button>
                      )}
                    </ButtonToolbar>
                   
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>Response </th>
                        <th>Zone Name</th>
                        <th>Basepack Code</th>
                        <th>CBU Code</th>
                        <th>Batch</th>
                        <th>LB SKU ID</th>
                        <th>LB SKU Product Name</th>                        
                        <th>MRP</th>
                        <th>UPC</th>
                        <th> PKD </th>
                        <th> Total Quantity </th>
                        <th>ICLD Quantity</th>
                        <th>Loose Quantity</th>
						{(this.state.pickType_optionval.toLowerCase() == "carton" || this.state.pickType_optionval == "outer")  && <th>CPO</th>}
						{(this.state.pickType_optionval.toLowerCase() == "carton" || this.state.pickType_optionval.toLowerCase() == "outer") && <th>Order Number</th>}
						{(this.state.pickType_optionval.toLowerCase() == "carton" || this.state.pickType_optionval.toLowerCase() == "outer") && <th>OCLD Quantity</th>}
						{(this.state.pickType_optionval.toLowerCase() == "carton" || this.state.pickType_optionval.toLowerCase() == "outer") && <th>OCLD Flag</th>}
						{(this.state.pickType_optionval.toLowerCase() == "carton" || this.state.pickType_optionval.toLowerCase() == "outer") && <th>Retailer Type</th>}
						{(this.state.pickType_optionval.toLowerCase() == "carton" || this.state.pickType_optionval.toLowerCase() == "outer") && <th>Priority</th>}
                        
                      </tr>
                    </thead>
                    <tbody>
					
					{console.log("DATA",this.state.data)}
                      {
						  
                      this.state.data.map((item, index) => (
                        <tr>
                          { item['error'] ? (
                            <td style={{"backgroundColor": "red", color: '#fff'}}> {item['error']} </td>

                            ) : (
                            <td style={{"backgroundColor": "green", color: '#fff'}}> No Error </td>

                            )
                          }
                          <td>{item['Zone']}</td>
                          <td>{item['Basepack Code']}</td>
                          <td>{item['CBU Code']}</td>
                          <td>{item['Batch']}</td>
                          <td>{item['LB SKU ID']}</td>
                          <td>{item['LB SKU Product Name']}</td>
                          <td>{item['MRP']}</td>
                          <td>{item['UPC']}</td>
                          <td>{item['PKD']}</td>
                          <td>{item['Total Quantity']}</td>
                          <td>{item['ICLD Quantity']}</td>
                          <td>{item['Loose Quantity']}</td>
						  {(this.state.pickType_optionval.toLowerCase() == "carton" || this.state.pickType_optionval.toLowerCase() == "outer")  && <td>{item['CPO']}</td>}
							{(this.state.pickType_optionval.toLowerCase() == "carton" || this.state.pickType_optionval.toLowerCase() == "outer") && <td>{item['Order Number']}</td>}
							{(this.state.pickType_optionval.toLowerCase() == "carton" || this.state.pickType_optionval.toLowerCase() == "outer") && <td>{item['OCLD Quantity']}</td>}
							{(this.state.pickType_optionval.toLowerCase() == "carton" || this.state.pickType_optionval.toLowerCase() == "outer") && <td>{item['OCLD Flag']}</td>}
							{(this.state.pickType_optionval.toLowerCase() == "carton" || this.state.pickType_optionval.toLowerCase() == "outer") && <td>{item['Retailer Type']}</td>}
							{(this.state.pickType_optionval.toLowerCase() == "carton" || this.state.pickType_optionval.toLowerCase() == "outer") && <td>{item['Priority']}</td> }
						                    
                        </tr>
                      ))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }


          {
            this.state.showTesterItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div className="table_header">
                    <ButtonToolbar className="form__button-toolbar">
                      {this.state.showProceedbtn && (
                      <Button color="primary" className="btn-sm show_confirm_button" onClick={this.processData} type="submit" style={{textTransform:'capitalize'}}>
                      {this.state.loadingconfirmbtn && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    } 
                      Confirm</Button>
                      )}
                    </ButtonToolbar>
                   
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>Response </th>
                        <th>PTL ID</th>
                        <th>Zone</th>
                        <th>Order Date</th>
                        <th>Tester Order Number</th>
                        <th>Party Code </th>
                        <th>Party Name</th>                        
                        <th>Sales Beat</th>
                        <th>Basepack Code</th>
                        <th> Shade Code </th>
                        <th> Shade Name </th>
                        <th>Product Description</th>
                        <th>Order Quantity</th>
                        
                       
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                      {
                      
                      this.state.data.map((item, index) => (
                        <tr>
                          { item['error'] ? (
                            <td style={{"backgroundColor": "red", color: '#fff'}}> {item['error']} </td>

                            ) : (
                            <td style={{"backgroundColor": "green", color: '#fff'}}> No Error </td>

                            )
                          }
                          <td>{item['PTL ID']}</td>
                          <td>{item['Zone']}</td>
                          <td>{item['Order Date']}</td>
                          <td>{item['Tester Order Number']}</td>
                          <td>{item['Party Code']}</td>
                          <td>{item['Party Name']}</td>
                          <td>{item['Sales Beat']}</td>
                          <td>{item['Basepack Code']}</td>
                          <td>{item['Shade Code']}</td>
                          <td>{item['Shade Name']}</td>
                          <td>{item['Product Description']}</td>
                          <td>{item['Order Quantity']}</td>
                          

                          
                          
                          
                        </tr>
                      ))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }










        </Card>






        <Modal
          isOpen={modal}
          toggle={this.toggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>Successfully Uploaded</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.toggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={showInvalidModal}
          toggle={this.toggleInvalidModal}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4> Please Select a valid file format. <br/> (.xls , xlsx , csv) </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.toggleInvalidModalCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}

          style={{maxWidth: 578}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggleFailed} />
           
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
             <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4> This file contains some errors, Please Upload a valid file.</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button  className="modal_cancel"  onClick={this.togglePressCancel}>Cancel</button>
            
          </ButtonToolbar>
        </Modal>



        <Modal
          isOpen={SuccessConfirmmodal}
          toggle={this.SuccessConfirmtoggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.SuccessConfirmtoggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.SuccessConfirmoktoggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>
		
		<Modal
          isOpen={this.state.responseModal}
          toggle={this.responseModalToggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.responseModalToggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>{this.state.responseModalMsg}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#ddd', color: '#fff'}} className="modal_ok"  onClick={this.responseModalToggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>


      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));